import * as React from "react";
import * as styles from "source/app/presentation/MainPanel/Workflows/SearchNodes/SearchNodes.css";
import { RenderDiv } from "source/app/presentation/Shared/Render";

export function DisplayFavoritesInfo({
    showFavorites,
}: {
    showFavorites: boolean;
}) {
    return (
        <RenderDiv
            id="displayFavoritesInfo"
            when={showFavorites}
            withClasses={styles.favoritesHeader}
        >
            <span>Favorites</span>
        </RenderDiv>
    );
}
